import { getQueryStringParameters } from './query-utils';

export function getVerboseActive(): boolean {
  const verboseQueryStringValue = (getQueryStringParameters()?.verbose as string)?.toLowerCase();
  return verboseQueryStringValue === 'true' || verboseQueryStringValue === '';
}
